import { FilterChip } from './FilterChip'
import { createColor } from './criteria'
import type { FilterCriteria } from './types'

export type UseSetChristmas = () => (christmas: boolean) => void

export function Christmas({
  useFilterCriteria,
  useChristmas,
  useSetChristmas,
  useEnabledChristmas,
}: {
  useFilterCriteria: () => FilterCriteria | undefined
  useChristmas: () => boolean
  useSetChristmas: UseSetChristmas
  useEnabledChristmas: () => boolean
}) {
  const criteria = useFilterCriteria()
  const hasChristmas = useChristmas()
  const set = useSetChristmas()
  const enabled = useEnabledChristmas()
  const color = createColor({ enabled, isActive: criteria?.christmas })
  if (!hasChristmas) {
    return null
  }
  return (
    <FilterChip onClick={() => set(!criteria?.christmas)} color={color}>
      クリスマス
    </FilterChip>
  )
}
